// ***************************************************
// pathname: /v1/missing-info
// ***************************************************
import { useSwrApi } from '@hooks/useSwrApi';

/** Props */
interface UseSwrMissingInfoProps {
  locale: string,
  shouldFetch?: boolean,
  type?: 'business' | 'personal',
}

/**
 * @description SWR: find out what info is missing for the user.
 * - `locale` - the Locale
 * - `shouldFetch` - boolean, if the data should be fetched or not
 * - `type` - string, the type of missing info; 'business' or 'personal'
 */
export const useSwrMissingInfo = (props: UseSwrMissingInfoProps) => {
  const {
    locale,
    shouldFetch = true,
    type,
  } = props;

  return useSwrApi<ApiSchema<'MissingInfo'>>({
    url: '/v1/missing-info',
    urlParams: type ? `?type=${type}` : '',
    locale,
    shouldFetch,
    apiOptions: {
      revalidateOnFocus: false,
    },
  });
};
